module.exports = __webpack_public_path__ + "static/media/logo-spin.05e15581.png";